import { ApiClient } from '../../../../infra';
import { fromBackend } from '../../../../domain';
/**
 * O "Apurado em" e um instante: volta no fuso de quem olha. Os baldes das series sao
 * DIAS (o servidor ja os conta no dia do produto) e nao passam por aqui.
 */
function periodFromBackend(answer) {
    return answer.period
        ? { ...answer, period: { ...answer.period, generatedAt: fromBackend(answer.period.generatedAt) } }
        : answer;
}
/**
 * O que a Adocao e Engajamento pede ao servidor.
 *
 * Tres perguntas, uma por aba, e nenhuma outra tela as faz - por isso moram na
 * pasta da tela. A tela e dona do que ela pede tanto quanto do que ela desenha.
 *
 * O transporte e a sessao sao do `ApiClient`, em `infra/`, que e o unico lugar que
 * conhece token, `baseUrl` e a politica do 401/403 - e que nao pode divergir entre
 * areas.
 */
export class UserBaseApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new UserBaseApi(); }
    async fetchOverview(query, signal) {
        return periodFromBackend((await this.client.send('POST', '/dashboard/user-base/overview', query, signal)));
    }
    async fetchTraining(query, signal) {
        return periodFromBackend((await this.client.send('POST', '/dashboard/user-base/training', query, signal)));
    }
    async fetchPhysical(query, signal) {
        return periodFromBackend((await this.client.send('POST', '/dashboard/user-base/physical', query, signal)));
    }
    /**
     * A bateria dos vestiveis - pulseira e anel.
     *
     * `undefined` quando o servidor ainda nao tem o painel (404): a secao so some, e o resto
     * da tela segue. E o que o painel antigo faz desde a 0.9.0.
     */
    async fetchDevices(query, signal) {
        try {
            return periodFromBackend((await this.client.send('POST', '/dashboard/user-base/devices', query, signal)));
        }
        catch (caught) {
            if (caught instanceof Error && caught.message.startsWith('404')) {
                return undefined;
            }
            throw caught;
        }
    }
}
//# sourceMappingURL=user-base.api.js.map